import { gql } from "apollo-boost"

export const GET_BENEFICIARIES_BY_SUBMISSION = gql`
  query BeneficiariesBySubmission ($id:ID!) {
    BeneficiariesBySubmission (id: $id){
      id
      name
    }
  }
`